module.exports = __webpack_public_path__ + "img/cta-arrow-black.ff2e0009.svg";